export default __webpack_public_path__ + "static/media/deposit-gpay-step3.6e0e0c29.png";